"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourceType = exports.FileSharingProtocolType = exports.PersonType = exports.MessageType = exports.DeliveryMode = exports.MessageContentType = void 0;
var MessageContentType = /** @class */ (function () {
    function MessageContentType() {
    }
    MessageContentType.RichText = "RichText";
    MessageContentType.Text = "Text";
    return MessageContentType;
}());
exports.MessageContentType = MessageContentType;
var DeliveryMode = /** @class */ (function () {
    function DeliveryMode() {
    }
    DeliveryMode.Bridged = "bridged";
    DeliveryMode.Unbridged = "unbridged";
    return DeliveryMode;
}());
exports.DeliveryMode = DeliveryMode;
var MessageType = /** @class */ (function () {
    function MessageType() {
    }
    MessageType.UserMessage = "UserMessage";
    MessageType.SwiftCard = "SwiftCard";
    MessageType.Typing = "Control/Typing";
    MessageType.ClearTyping = "Control/ClearTyping";
    MessageType.LiveState = "Control/LiveState";
    return MessageType;
}());
exports.MessageType = MessageType;
var PersonType;
(function (PersonType) {
    PersonType[PersonType["Unknown"] = 0] = "Unknown";
    PersonType[PersonType["User"] = 1] = "User";
    PersonType[PersonType["Bot"] = 2] = "Bot";
})(PersonType = exports.PersonType || (exports.PersonType = {}));
var FileSharingProtocolType;
(function (FileSharingProtocolType) {
    FileSharingProtocolType[FileSharingProtocolType["AmsBasedFileSharing"] = 0] = "AmsBasedFileSharing";
})(FileSharingProtocolType = exports.FileSharingProtocolType || (exports.FileSharingProtocolType = {}));
var ResourceType = /** @class */ (function () {
    function ResourceType() {
    }
    ResourceType.NewMessage = "NewMessage";
    ResourceType.MessageUpdate = "MessageUpdate";
    ResourceType.UserPresence = "UserPresence";
    ResourceType.ConversationUpdate = "ConversationUpdate";
    ResourceType.ThreadUpdate = "ThreadUpdate";
    return ResourceType;
}());
exports.ResourceType = ResourceType;
//# sourceMappingURL=OmnichannelMessage.js.map